import { useState } from 'react';

const galleryImages = [
  {
    src: 'https://public.readdy.ai/ai/img_res/acd4ddc9824cf0101cb7d09bb8f16948.jpg',
    alt: 'コワーキングスペースで作業する様子',
    span: 'row-span-2',
    width: 600,
    height: 800,
  },
  {
    src: 'https://readdy.ai/api/search-image?query=premium%20black%20ergonomic%20office%20chair%20MeVER%20design%20in%20modern%20coworking%20space%20with%20wooden%20desk%20laptop%20natural%20lighting%20minimalist%20Japanese%20workspace%20professional%20product%20photography&width=600&height=400&seq=favy-cowork-gal-002&orientation=landscape',
    alt: 'MeVER Chair ディテール',
    span: '',
    width: 600,
    height: 400,
  },
  {
    src: 'https://readdy.ai/api/search-image?query=modern%20Japanese%20food%20hall%20interior%20with%20wooden%20tables%20comfortable%20seating%20coffee%20bar%20area%20warm%20ambient%20lighting%20green%20plants%20minimalist%20design%20coworking%20cafe%20space%20professional%20architectural%20photography&width=600&height=400&seq=favy-cowork-gal-003&orientation=landscape',
    alt: 'フードホール（5F）',
    span: '',
    width: 600,
    height: 400,
  },
  {
    src: 'https://readdy.ai/api/search-image?query=modern%20meeting%20room%20with%20glass%20walls%20long%20wooden%20table%20ergonomic%20chairs%20whiteboard%20projector%20screen%20minimalist%20Japanese%20design%20natural%20lighting%20professional%20business%20space%20architectural%20photography&width=600&height=400&seq=favy-cowork-gal-004&orientation=landscape',
    alt: 'ミーティングルーム',
    span: '',
    width: 600,
    height: 400,
  },
  {
    src: 'https://readdy.ai/api/search-image?query=modern%20coworking%20lounge%20area%20with%20comfortable%20sofas%20low%20tables%20green%20plants%20warm%20wood%20accents%20natural%20lighting%20minimalist%20Japanese%20interior%20design%20relaxation%20space%20professional%20architectural%20photography&width=600&height=800&seq=favy-cowork-gal-005&orientation=portrait',
    alt: 'ラウンジエリア',
    span: 'row-span-2',
    width: 600,
    height: 800,
  },
  {
    src: 'https://readdy.ai/api/search-image?query=overhead%20aerial%20view%20of%20modern%20Japanese%20coworking%20space%20with%20multiple%20wooden%20desks%20ergonomic%20chairs%20people%20working%20on%20laptops%20natural%20daylight%20green%20plants%20organized%20workspace%20professional%20architectural%20photography&width=600&height=400&seq=favy-cowork-gal-006&orientation=landscape',
    alt: 'オープンスペース全景',
    span: '',
    width: 600,
    height: 400,
  },
];

export default function CoworkingGallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openLightbox = (index: number) => {
    setActiveIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const goNext = () => {
    setActiveIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const goPrev = () => {
    setActiveIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <section className="py-16 sm:py-24 md:py-32 bg-[#FAF8F5]" aria-labelledby="gallery-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <span className="inline-block px-3 py-1.5 bg-emerald-500/10 text-emerald-600 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            GALLERY
          </span>
          <h2
            id="gallery-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]"
          >
            空間の魅力
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide">
            実際のコワーキングスペースの雰囲気をご覧ください
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 auto-rows-[200px] sm:auto-rows-[240px]">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className={`group relative rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer ${img.span}`}
              onClick={() => openLightbox(index)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
                width={img.width}
                height={img.height}
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                <div className="w-10 h-10 flex items-center justify-center bg-white/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-75 group-hover:scale-100">
                  <i className="ri-zoom-in-line text-lg text-black" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label="画像ビューア"
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center text-white/80 hover:text-white cursor-pointer z-10"
            onClick={closeLightbox}
            aria-label="閉じる"
          >
            <i className="ri-close-line text-2xl" aria-hidden="true"></i>
          </button>

          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white/60 hover:text-white bg-white/10 hover:bg-white/20 rounded-full cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
            aria-label="前の画像"
          >
            <i className="ri-arrow-left-s-line text-2xl" aria-hidden="true"></i>
          </button>

          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white/60 hover:text-white bg-white/10 hover:bg-white/20 rounded-full cursor-pointer z-10"
            onClick={(e) => { e.stopPropagation(); goNext(); }}
            aria-label="次の画像"
          >
            <i className="ri-arrow-right-s-line text-2xl" aria-hidden="true"></i>
          </button>

          <div
            className="max-w-5xl max-h-[85vh] w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={galleryImages[activeIndex].src}
              alt={galleryImages[activeIndex].alt}
              className="w-full h-full object-contain rounded-lg"
            />
            <p className="text-center text-white/60 text-sm font-extralight mt-4 tracking-wide">
              {galleryImages[activeIndex].alt}
              <span className="ml-3 text-white/40">{activeIndex + 1} / {galleryImages.length}</span>
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
